import { apiSlice } from '../../app/services/apiSlice';

const BASE_URL = 'authentication/auth';
const Vendor_BASE_URL = '/vendor/florist';
const APIV2 = '/v2';

export const onboardingDashboardApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOnboardingChecklist: builder.query({
      query: () => ({
        url: `${BASE_URL}/goLivePreChecks`,
      }),
      providesTags: ['SubscriptionDetail', 'preLiveChecks'],
      transformResponse: (response) => response?.objectData,
    }),
    updateCompleteOnboardingStatus: builder.mutation({
      query: (body) => ({
        url: `${Vendor_BASE_URL}/completeOnboarding`,
        method: 'PUT',
        body: body,
      }),
      invalidatesTags: ['preLiveChecks'],
      transformResponse: (response) => response?.objectData,
    }),
    getDashboardKPI: builder.query({
      query: (params) => ({
        url: `/inventory/api/sale/dashboard/kpis`,
        params: params,
      }),
      providesTags: ['dashboardMetrics'],
      transformResponse: (response) => response?.objectData,
    }),
    getDashboardPieChartData: builder.query({
      query: ({ type, params }) => ({
        url: `/inventory/api/sale/dashboard/salesStatistics/piechart/${type}`,
        params: params,
      }),
      providesTags: ['dashboardMetrics'],
      transformResponse: (response) => response?.objectData,
    }),
    getDashboardLineChartData: builder.query({
      query: ({ type, params }) => ({
        url: `/inventory/api/sale/dashboard/salesStatistics/linechart/${type}`,
        params: params,
      }),
      providesTags: ['dashboardMetrics'],
      transformResponse: (response) => response?.objectData,
    }),
    getDashboardTopProducts: builder.query({
      query: ({ type, params }) => ({
        url: `/inventory/api/sale/dashboard/salesStatistics/products/${type}/top`,
        params: params,
      }),
      providesTags: ['dashboardMetrics'],
      transformResponse: (response) => response?.objectData,
    }),
    getDashboardBottomProducts: builder.query({
      query: ({ type, params }) => ({
        url: `/inventory/api/sale/dashboard/salesStatistics/products/${type}/bottom`,
        params: params,
      }),
      providesTags: ['dashboardMetrics'],
      transformResponse: (response) => response?.objectData,
    }),
    getSalesOrdersList: builder.mutation({
      query: (params) => ({
        url: `inventory/api/sale/dashboard${APIV2}/salesStatistics/order/listing`,
        params,
      }),
      transformResponse: (response) => response?.objectData,
    }),
    getPermissions: builder.query({
      query: () => ({
        url: `${BASE_URL}/resources/list`,
      }),
      providesTags: ['SubscriptionDetail', 'preLiveChecks'],
      transformResponse: (response) => response?.objectData,
    }),
    getCommissionInsights: builder.query({
      query: () => ({
        url: `inventory/api/florist/inventory/insights/all/contributed/total/totalSales`,
      }),
      transformResponse: (response) => response?.objectData,
    }),
  }),
});

export const {
  useGetOnboardingChecklistQuery,
  useUpdateCompleteOnboardingStatusMutation,
  useGetDashboardKPIQuery,
  useGetDashboardLineChartDataQuery,
  useGetDashboardPieChartDataQuery,
  useGetDashboardTopProductsQuery,
  useGetDashboardBottomProductsQuery,
  useGetSalesOrdersListMutation,
  useGetPermissionsQuery,
  useGetCommissionInsightsQuery
} = onboardingDashboardApiSlice;
